import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Badge from 'Components/Badge/Badge.jsx';
import Button from 'Components/Button';
import CloseIcon from 'Components/icons/CloseIcon';
import DownArrowIcon from 'Components/icons/DownArrowIcon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import LeftPointerIcon from 'Components/icons/left-pointer-icon/LeftPointerIcon';
import UpArrowIcon from 'Components/icons/UpArrowIcon';
import { customFormatclass, customClassCurrency } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell';
import GDDateCell from 'Components/GDTable/GDDateCell';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import CardType from 'Components/CardType';
import GDTable from 'Components/GDTable';

import EmptyState from 'Components/EmptyState/EmptyState';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon';
import counterpart from 'counterpart';
import './GDDetailView.scss';

const buttonText = '';
const GDDetailView = ({
  data,
  recordCountSize,
  selectedKeyIndex,
  extraClass,
  goToPreviousRecord,
  goToNextRecord,
  gotoExtraCaseDetailsPage,
  goBack,
  structure,
  type,
  preferences,
  isPrevBtnDisabled,
  isNextBtnDisabled,
  tableMetaData,
  dateFormat,
  pageHandler,
  handleSort,
  caseDataErr,
  isLoading,
  rowActionClick,
  translations,
  hideFlag,
  // gotoExtraCaseDetailsPage,
  configId,
  drawerdataErr,
  isdataLoading,
  isOperationsReport,
  isInternalUser,
  isMerchantUser,
  newTabToggle,
  isCitiUser,
  caseLandingHistory,
  caseHeaderDrawer
}) => {
  const wrapperClass = classnames('gd-detail-view', {
    [extraClass]: extraClass,
  });

  let structure1 = [];
  structure1 = structure1.concat(structure[0]);
  let structure2 = [];
  structure2 = structure2.concat(structure[1]);

  function getItemData(item) {
    const itemKey = item.columnKey;
    let itemSpan = [];
    let checkData = [];

    if (item.displayType === 'MULTI_VALUE') {
      for (const key in itemKey) {
        if (data[`${itemKey[key]}`] != null && data[`${itemKey[key]}`] != undefined)
          checkData = checkData.concat(data[`${itemKey[key]}`]);

        if (checkData.length != 0) {
          itemSpan = itemSpan.concat(<span>{data[`${itemKey[key]}`]}</span>);
          itemSpan = itemSpan.concat("  ");
        }
        if(isMerchantUser && item.description==='Settled'){
        if (data[`${item.columnKey.value1}`] != null) {
          return (
            <div><span>
                <GDDateCell
                  key={`${item.columnKey.value1}`}
                  date={data[`${item.columnKey.value1}`]}
                  dateFormat={preferences.dateFormat} /></span>
                  <span> {getCurrencyCell(data[item.columnKey.value2], data[item.columnKey.value3], item.columnKey.value2, item.columnKey.value3)}</span></div>

          
          );}
        }
      }
      if (checkData.length == 0)
        return <span>--</span>;
      else
        return <div>{itemSpan}</div>;
    }
    if (item.displayType === 'STRING-STRING') {
      return (
        <div>
          <span>{data[`${item.columnKey.value1}`]? data[`${item.columnKey.value1}`] : '--'} - {data[`${item.columnKey.value2}`] ? data[`${item.columnKey.value2}`] : '--'}</span>
        </div>
      );
    }
    if (item.displayType === 'CURRENCY_UNIT' && item.columnKey.value1) {
      return (
        <span className="currency-cell">{handlePrecision(data[item.columnKey.value1], 2 )}</span>
      );
    }else if (item.displayType === 'CURRENCY_UNIT') {
      return (
        <span className="currency-cell">{handlePrecision(data[item.columnKey], 2 )}</span>
      );
    }
    else if (data[`${itemKey}`] !== null && data[`${itemKey}`] !== undefined && `${data[`${itemKey}`]}`.trim() !== '') {
      const badgeType = isMerchantUser ? data.merchantStatusId : data[`${item.columnKey}`];
      if (item.displayType === 'BADGE') {
        return (
          <Badge
            badgeType={badgeType}
            key={`${item.columnKey}`}
            square={false}
          >
            {data[`${item.columnKey}`]}
          </Badge>
        );
      }
      else if (item.displayType === 'CC_BADGE') {
        return (
          <CardType
            abbreviation={data[item.columnKey].toUpperCase()}
            type={data[item.columnKey].toUpperCase()}
          />
        );
      }

      else if (item.displayType === 'DATE') {
        return (
          <GDDateCell
            key={`${item.columnKey}`}
            date={data[`${item.columnKey}`]}
            dateFormat={preferences.dateFormat}
            timeFormat={preferences.timeFormat}
          />
        );
      } else if (item.displayType === 'DUEDATE') {
        return (
          <GDDateCell
            key={`${item.columnKey}`}
            date={data[`${item.columnKey}`]}
            dateFormat={preferences.dateFormat}
            timeFormat={preferences.timeFormat}
          />
        );
      } else if (item.displayType === 'INDICATOR') {
        return (
          <span key={`${item.columnKey}`}>
            {data[item.columnKey] === '1' ? 'Yes' : data[item.columnKey] === '9'?" ": 'No'}
          </span>
        );
      } else if (item.columnKey === 'card_type') {
        return (
          <CardType
            abbreviation={data[item.columnKey]}
            type={data[item.columnKey]}
          />
        );
      } else if (item.displayType === 'ACCOUNTNUMBER') {
        return (
          <GDAccountNumberCell
            accountNumber={data[`${itemKey}`]}
            token={data[item.secondaryColumnKey === undefined ? 'globalToken' : item.secondaryColumnKey]}
            isMerchantPortal={isMerchantUser}
          />
        );
      } else if (item.displayType === 'CURRENCY' || item.displayType === 'NEGATIVE_NUMBER') {
        var normalizedUnits = data[item.columnKey].units || '';
        if (data['disputeCurrencyCode'] !== undefined) {
          normalizedUnits = data['disputeCurrencyCode'] || '';
        }
        else if (data['tranCurrencyCode'] !== undefined) {
          normalizedUnits = data['tranCurrencyCode'] || '';
        }
        else
          normalizedUnits = data['currencyCode'] || '';

        if(item.description == "Transaction Amount"){
          normalizedUnits = ''
        }
        if (normalizedUnits !== '') {
          const normalizedValue = data[item.columnKey].value || data[item.columnKey] || '--';
          let valueClass;
          if (Number.isNaN(Number.parseFloat(normalizedValue))) {
            return <span key={`${item.columnKey}`}>{normalizedValue}</span>;
          }
          if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
          return (
            <GDCurrencyCodeCell
              key={`${item.columnKey}`}
              value={normalizedValue}
              units={normalizedUnits}
              customClass={valueClass}
            />
          );
        } else {
          let valueClass;
          const normalizedValue = data[item.columnKey] !== '' ? data[item.columnKey] : '--';
          if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
          return (
            <GDCurrencyCodeCell
              key={`${item.columnKey}`}
              value={normalizedValue}
              customClass={valueClass}
            />
          );
        }
      }
      if (item.displayType === 'CURRENCY_UNIT' && item.columnKey.value1) {
        return (
          <span className="currency-cell">{handlePrecision(data[item.columnKey.value1], 2 )}</span>
        );
      }else if (item.displayType === 'CURRENCY_UNIT') {
        return (
          <span className="currency-cell">{handlePrecision(data[item.columnKey], 2 )}</span>
        );
      }
      else {

        return <span>{data[`${item.columnKey}`]} </span>


      }
    }
    return <span>--</span>;
  }

  function handlePrecision(amount, precision) {
    if (amount !== undefined && amount !== null) {
      const arr = `${amount}`.split('.');
      return arr.length > 1
        ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
        : `${amount <= 0 ? amount * -1 : amount}.00`;
    }
    return '--';
  };

  function getCurrencyCell(amount, currency, columnKey1, columnKey2) {
    if (currency !== undefined) {
      const normalizedValue = amount == 0 ? 0 : (Math.round(amount * 100) / 100).toFixed(2) || '--';
      const normalizedUnits = currency || '';
      let valueClass;
      if (Number.isNaN(Number.parseFloat(amount))) {
        return <span key={`${columnKey1}`}>{normalizedValue}</span>;
      }

      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          units={normalizedUnits}
          customClass={valueClass}
        />
      );
    } else {
      let valueClass;
      const normalizedValue = amount !== '' ? amount : '--';
      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          customClass={valueClass}
        />
      );
    }
  };


  function getCategories(structure) {
    if (type === 'report' || type === 'caseLandingReport') {
      return (
        structure.map((category) => {
          document.body.style.overflow = 'hidden';
          let dataColumn1 = isCitiUser ? category.dataColumns?.filter(item => item.name !== 'Authorized') : category.dataColumns;
          return (
            <div className="gd-detail-view__items-wrapper" key={category.categoryKey}>
              <div className="gd-detail-view__items">
                {dataColumn1.map((item) => {
                  return item.name === '' || item.description === '' ? '' : (
                    <div className="gd-detail-view__item" key={item.id}>
                      <span id={`${category.detailViewTitle}_GDDetailView_lbl_${item.name}`} className="gd-detail-view__item-title">
                        {item.name} 
                        {item.descriptionKey && item.displayType === 'RC' ? (	
                          <InformationBubble	
                            id={item.descriptionKey}	
                            info	
                            position	
                            tooltipContent={data[`${item.descriptionKey}`]}	
                          />	
                        ) : ( item.descriptionKey && 	
                            <InformationBubble	
                              id={item.name}	
                              info	
                              position	
                              tooltipContent={item.description}	
                            />	
                          )	
                        }
                      </span>
                      <span id={`${category.detailViewTitle}_GDDetailView_${item.name}_value_${data[`${item.columnKey}`]}`} className="gd-detail-view__item-data">
                        {getItemData(item)}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })
      );
    }
  }

  const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode=="HPY"? "HPY" :"";

  return (
    <div className={wrapperClass}>
      <div className="gd-detail-view__flex">
        <div className={"gd-detail-view__controls gd-detail-view__controls"+acquirerCode}>
          <div className="gd-detail-view__controls--left">
            <Button
              id={`${structure[0].detailViewTitle}_GDDetailView_btn_return`}
              action={goBack}
              category="hollow toggled"
              icon={LeftPointerIcon}
              iconDirection="left"
              style={acquirerCode=="HPY"?{ border: "1px solid #1362E2",background:"#FFFFFF"}: {}}
            >
              {buttonText}
            </Button>
            <h2 className="gd-detail-view__controls-title">
              {structure[0].returnToText}
            </h2>
          </div>
          <div className="gd-detail-view__controls--right">
            {!hideFlag && <Button
              id={`${structure[0].detailViewTitle}_GDDetailView_btn_DownArrow`}
              action={goToNextRecord}
              disabled={type === 'report' ? selectedKeyIndex + 1 === recordCountSize : isNextBtnDisabled}
              category="hollow toggled"
              iconDirection="left"
              icon={DownArrowIcon}
            >
              {buttonText}
            </Button>}
            {!hideFlag && <Button
              id={`${structure[0].detailViewTitle}_GDDetailView_btn_UpArrow`}
              action={goToPreviousRecord}
              disabled={type === 'report' ? selectedKeyIndex === 0 : isPrevBtnDisabled}
              category="hollow toggled"
              iconDirection="left"
              icon={UpArrowIcon}
            >
              {buttonText}
            </Button>}
            {newTabToggle &&  type === 'caseLandingReport' && <div className={"OpenNewWindowIcon OpenNewWindowIcon"+acquirerCode}><div className="inner-div"><OpenNewWindowIcon
              onClick={() => gotoExtraCaseDetailsPage(1)}
            /></div></div>}
            <Button
              id={`${structure[0].detailViewTitle}_GDDetailView_btn_close`}
              action={goBack}
              category="primary toggled"
              iconDirection="left"
              icon={CloseIcon}
              style={acquirerCode=="HPY"?{ background:"#262aff", color:"white"}: {}}
            >
              {buttonText}
            </Button>
          </div>
        </div>
        <div className="gd-detail-view__scroller">
          <div className="gd-detail-view__header">
            <h1>
              {type === 'caseLandingReport' && structure[0].detailViewTitle}
              {type === 'report' && structure[0].detailViewTitle}
              {type === 'gdTable' && `${data.firstName} ${data.lastName}'s Queue`}
              {              	
              newTabToggle && isInternalUser && type === 'report' && !drawerdataErr && !isOperationsReport &&	
              <div className="expand-icon" style = {{width: '25px',float:'right'}}>	
                <OpenNewWindowIcon	
                  onClick={() => gotoExtraCaseDetailsPage(configId)}	
                />	
              </div>	
            } 
            </h1>
            {
              !isInternalUser && type === 'report' && !hideFlag  && !isOperationsReport && <div className="gd-detail-view__header--right"><Button
                id={`${structure[0].detailViewTitle}_GDDetailView_btn_open`}
                action={() => { rowActionClick(selectedKeyIndex,'OC') }}
                category="hollow toggled"
                extraClass="open-button"
              >
                Open Case
              </Button></div>
            }
            {!isdataLoading && caseHeaderDrawer && caseLandingHistory && (structure[0].detailViewTitle === "Case Data" || structure[0].detailViewTitle === "Card Brand Data") && (<>
              <span className='stage_name'>&nbsp; - &nbsp;{caseLandingHistory[0].disputeStageName}</span></>)}
            {!isdataLoading && caseHeaderDrawer && caseLandingHistory && structure[0].detailViewTitle === "Case Data" && (<>
              <span className='stage_name'>&nbsp; - &nbsp;{caseLandingHistory[0].caseStageId}</span></>)}
          </div>
          {type === 'caseLandingReport' && (
            <div>

              <div className="gd-detail-view__section">
                <div className={"header header"+acquirerCode}><div className="font-style" >{type === 'caseLandingReport' && structure[0].name}</div></div>
                {getCategories(structure1)}</div>
              <div className="gd-detail-view__section">
                <div className={"header header"+acquirerCode}><div className="font-style" >{type === 'caseLandingReport' && structure[1].name}</div></div>
                {getCategories(structure2)}</div>
            </div>
          )}

          {!isInternalUser && type === 'report' && (
            <div>

              <div className="gd-detail-view__section">
                {getCategories(structure)}</div>
            </div>
          )}
          {isInternalUser && type === 'report' && (	
            <div className="gd-detail-view__section">	
            {isdataLoading === true &&<BVLoader20 />}	
            {!isdataLoading && !drawerdataErr && (	
              getCategories(structure))}	
              {drawerdataErr && !isdataLoading && (	
                <EmptyState	
                  translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}	
                />	
              )	
              }	
          </div>	
          )}
          {type === 'gdTable' && (
            <div className="gd-detail-view__section">
              {isLoading === true &&<BVLoader20 />}
              {!isLoading && !caseDataErr && (
                <GDTable
                  className=""
                  report={tableMetaData.queueMetaData}
                  data={tableMetaData.caseData}
                  dateFormat={dateFormat}
                  currentPage={tableMetaData.currentPage}
                  sort={tableMetaData.sort}
                  pageHandler={pageHandler}
                  handleSort={handleSort}
                  translations={translations}
                  recordsCountText={{ showingRecords: '', preposition: '' }}
                  isPagable={tableMetaData.queueMetaData.isPagable}
                  totalPages={0}
                  isNextPage={tableMetaData.isNextPage}
                  exporting={tableMetaData.exporting}
                  totalRecords={tableMetaData.totalRecords}
                  isLoading={isLoading}
                  isFetchingData={isLoading}
                  actionButtonText=""
                  titleRequired={tableMetaData.queueMetaData.titleRequired}
                  isCheckboxOnRowRequired={tableMetaData.queueMetaData.isCheckboxOnRowRequired}
                  recordCountRequired={tableMetaData.queueMetaData.recordCountRequired}
                  showCaseCountDisplay={false}
                  rowActionClick={rowActionClick}
                  isAgGrid={true}
                  showFooter={false}
                  isAutoHeight={true}
                />
              )
              }
              {caseDataErr && !isLoading && (
                <EmptyState
                  translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}
                />
              )
              }
            </div>
          )
          }
        </div>
      </div>
    </div>
  );
};

GDDetailView.propTypes = {
  data: PropTypes.object,
  extraClass: PropTypes.string,
  goToPreviousRecord: PropTypes.func,
  goToNextRecord: PropTypes.func,
  goBack: PropTypes.func.isRequired,
  structure: PropTypes.array,
  type: PropTypes.string,
  preferences: PropTypes.object,
  isPrevBtnDisabled: PropTypes.bool,
  isNextBtnDisabled: PropTypes.bool,
  tableMetaData: PropTypes.object,
  dateFormat: PropTypes.string,
  pageHandler: PropTypes.func,
  handleSort: PropTypes.func,
  caseDataErr: PropTypes.bool,
  isLoading: PropTypes.bool,
  rowActionClick: PropTypes.func,
  translations: PropTypes.object,
  isMerchantUser: PropTypes.bool,
  newTabToggle: PropTypes.bool,
  isCitiUser: PropTypes.bool
};

GDDetailView.defaultProps = {
  data: {},
  extraClass: '',
  handleSort: () => { },
  pageHandler: () => { },
  structure: [],
  type: '',
  preferences: {},
  rowActionClick: () => { },
  translations: {},
  isInternalUser: true,
  isMerchantUser:false,
  newTabToggle: false,
};

export default GDDetailView;
